import { useNavigate } from "react-router-dom"
import RButton from "../generic/RButton"

// A list's New button, from its listHeader. It sits in the title row, or on a
// wide screen at the end of the filter cards (or the search row without them).
const CreateButton = ({ listHeader, entity }) => {
    const navigate = useNavigate()
    if (!listHeader?.createButton) return null

    return (
        <RButton
            $shadow={true}
            $variant="primary"
            $marginRight="0"
            onClick={() => navigate(`${listHeader.newPath}`)}
            testId={`${entity}.list.new`}
            label={listHeader.createButton}
        />
    )
}

export default CreateButton
